<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">
            <h2>Account</h2>

            <form v-on:submit="onSubmit" action="#" method="post" id="form">

                <FormBuilder :formData="formData" :formValue="member"></FormBuilder>

                <button class="right" v-bind:class="{ 'loading': isLoading }">Save</button>

            </form>
        </div>
    </div>
</template>

<script>
    import SideMenu from "../Components/SideMenuAccount.vue"
    import FormBuilder from "../Components/FormBuilder.vue"
    import { mapState } from "vuex"

    export default {
        components: {
            SideMenu,
            FormBuilder
        },
        data: () => ({
            emailError: null,
            isLoading: false,
            formData: [
                {
                    title: "Profile",
                    grid: "grid-50w",
                    forms: [
                        {
                            type: "text",
                            label: "First name",
                            placeholder: "John",
                            value: "firstName"
                        },{
                            type: "text",
                            label: "Last name",
                            placeholder: "Appleseed",
                            value: "lastName"
                        },{
                            type: "email",
                            label: "Email address",
                            placeholder: "johnappleseed@sponsor.com",
                            value: "email"
                        },{
                            type: "text",
                            label: "Company",
                            placeholder: "Company name",
                            value: "companyName"
                        }
                    ]
                }
            ]
        }),
        computed: mapState([
            "member"
        ]),
        methods: {
            onSubmit (e) {
                e.preventDefault();

                this.isLoading = true;

                this.emailError = this.member.email == null || this.member.email == "";
                if(this.emailError)
                {
                    this.isLoading = false;
                    return false;
                }

                this.$store.dispatch("setMember", this.member).then((res) => {

                    // Do some fake loading to show user it's saved
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 600);

                }).catch((res) => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>
